import Close from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DrawerHeaderContainer } from './styled';

type PropTypes = {
  onClick: () => void;
};

const Header = ({ onClick }: PropTypes) => {
  const { t } = useTranslation();

  return (
    <DrawerHeaderContainer data-testid="header-container">
      <Typography variant="body2">
        {t('aiMusicGenerator:sideBar:title')}
      </Typography>
      <Close onClick={onClick} />
    </DrawerHeaderContainer>
  );
};

export default Header;
